export const channel = 1; // 不传默认2-上上签，1-PDV
